export class BatteryVersion {
	code: string;
	name: string;
	commitedMinimumUsableEnergy: number;
	indicativeUsableEnergy: number;
	totalCapacity: number;
	maxTotalEnergy: number;
}
